<div class="agentic-agent-grid">
  <button
    type="button"
    class="agentic-agent-card"
    *ngFor="let agent of agents; trackBy: trackByAgent"
    [class.selected]="agent.key === selectedAgentKey"
    [class.disabled]="agent.disabled"
    [disabled]="agent.disabled"
    (click)="selectAgent(agent.key)"
  >
    <div class="agent-card-top">
      <div class="agent-title">
        <h2>{{ agent.label }}</h2>
        <p>{{ agent.provider }}</p>
      </div>

      <span
        class="agent-lead"
        *ngIf="agent.competitor"
        [class.up]="getLead(agent) > 0"
        [class.down]="getLead(agent) < 0"
      >
        <span class="agent-lead-arrow">{{ getLeadArrow(agent) }}</span>
        {{ getLeadLabel(agent) }}
      </span>
    </div>

    <div class="agent-score-row">
      <span class="agent-score-value" [style.color]="agent.scoreColor">
        {{ agent.score }}
      </span>
      <span class="agent-score-max">/100</span>
      <span class="agent-score-label">Visibility</span>
    </div>

    <div class="agent-compare">
      <span class="agent-compare-store" *ngIf="!agent.disabled">
        {{ agent.totalMatchedProducts }} of {{ agent.totalProducts }} products
      </span>
      <span class="agent-compare-store" *ngIf="agent.disabled">
        No data available
      </span>

      <span
        class="agent-compare-comp"
        *ngIf="agent.competitor as comp"
        [title]="comp.name"
      >
        <ng-container *ngIf="!comp.disabled; else compNoData">
          {{ comp.name }} {{ comp.score }}
        </ng-container>
        <ng-template #compNoData>
          <span class="muted">{{ comp.name }} &mdash;</span>
        </ng-template>
      </span>
    </div>
  </button>
</div>
